module.exports = __webpack_public_path__ + "img/itcan final logo.beb29470.png";